import { useRouter } from 'next/router';
/**
 * Hook for easily retrieving params from the next router query.
 *
 * @example
 * ```typescript
 * // Retrieve locationId and id params from the URL
 * const { locationId, id } = useQueryParams();
 * ```
 */
export function useQueryParams() {
  const { query } = useRouter();
  const destructibleObject: Record<string, string | undefined> = {};
  const keys = Object.keys(query);
  keys.forEach(key => {
    if (typeof query[key] === 'string') {
      destructibleObject[key] = query[key] as string;
    }
  });
  return destructibleObject;
}
